/* Quiénes somos · Valores accordion (port of QsValuesWf.tsx): one item open at a time.
   Delegated on document so it keeps working after theme-editor section reloads. */
(function () {
  if (window.__sfwQsAcc) return;
  window.__sfwQsAcc = true;

  function setItem(item, open) {
    var btn = item.querySelector('.sfw-qs-acc__btn');
    var clip = item.querySelector('.sfw-qs-acc__clip');
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (clip) {
      if (open) clip.removeAttribute('inert');
      else clip.setAttribute('inert', '');
    }
  }

  function openOnly(item, open) {
    var list = item.closest('[data-sfw-qs-acc]');
    if (!list) return;
    Array.prototype.forEach.call(list.querySelectorAll('.sfw-qs-acc__item'), function (it) {
      setItem(it, it === item ? open : false);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sfw-qs-acc] .sfw-qs-acc__btn');
    if (!btn) return;
    var item = btn.closest('.sfw-qs-acc__item');
    openOnly(item, !item.classList.contains('is-open'));
  });

  /* Theme editor: selecting a Valor block opens it. */
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('.sfw-qs-acc__item');
    if (item) openOnly(item, true);
  });
})();
